@if (_plan(); as plan) {
  <div
    class="approval"
    [class.approval--locked]="_resolvedDecision() !== null || superseded()"
    [class.approval--cancelled]="
      _resolvedDecision() === 'cancelled' ||
      (superseded() && _resolvedDecision() === null)
    "
  >
    <p class="approval-prompt">
      <i class="myre-icon-alert"></i>
      <span>{{ _prompt() }}</span>
    </p>

    @if (_message(); as message) {
      <div class="approval-email">
        <dl class="approval-email-headers">
          <dt>{{ _w.emailToLabel() }}</dt>
          <dd>{{ _displayTo().join(', ') }}</dd>
          @if (_displayCc().length) {
            <dt>{{ _w.emailCcLabel() }}</dt>
            <dd>{{ _displayCc().join(', ') }}</dd>
          }
          <dt>{{ _w.emailBccLabel() }}</dt>
          <dd>{{ message.bcc }} {{ _w.emailBccYou() }}</dd>
          <dt>{{ _w.emailSubjectLabel() }}</dt>
          <dd>{{ _displaySubject() }}</dd>
        </dl>
        @if (_recipientsPrivate()) {
          <p class="approval-email-private-note">
            <i class="myre-icon-eye-off"></i>
            {{ _w.recipientsPrivateNote() }}
          </p>
        }
        @if (_displayAttachments().length) {
          <div class="approval-email-attachments">
            <span class="approval-email-attachments-label">{{
              _w.attachmentsLabel()
            }}</span>
            @for (name of _displayAttachments(); track $index) {
              <span class="approval-email-attachment">
                <i class="myre-icon-attachment"></i>
                {{ name }}
              </span>
            }
          </div>
        }
        <div class="approval-email-body" [innerHTML]="_bodyHtml()"></div>
        @if (!_locked && !_arming()) {
          <div class="approval-email-edit-row">
            <button
              class="approval-button-edit-draft"
              type="button"
              (click)="_onEditDraft()"
            >
              <i class="myre-icon-edit"></i>
              {{ _w.approvalEditDraft() }}
            </button>
          </div>
        }
      </div>
    } @else if (plan.summary) {
      <p class="approval-summary">{{ plan.summary }}</p>
    }

    @if (_changes().length) {
      <ul class="approval-changes">
        @for (change of _changes(); track $index) {
          <li
            class="approval-change"
            [class.approval-change--destructive]="change.destructive"
          >
            <span class="approval-change-field">{{ change.field }}</span>
            <span class="approval-change-values">
              <span class="approval-change-current">{{ change.current }}</span>
              <i class="myre-icon-arrow-right"></i>
              <span class="approval-change-proposed">{{
                change.proposed
              }}</span>
            </span>
            <span class="approval-change-source">{{ change.source }}</span>
          </li>
        }
      </ul>
    }

    @if (_operations().length) {
      <ul class="approval-operations">
        @for (operation of _operations(); track $index) {
          <li
            class="approval-operation"
            [class.approval-operation--destructive]="operation.destructive"
          >
            <span class="approval-operation-op">{{ operation.op }}</span>
            <span class="approval-operation-target">{{
              operation.target
            }}</span>
            <span class="approval-operation-summary">{{
              operation.summary
            }}</span>
            @if (operation.ref) {
              <span class="approval-operation-ref">{{ operation.ref }}</span>
            }
            @if (operation.destructive) {
              <span class="approval-operation-badge">{{
                _w.approvalDestructive()
              }}</span>
            }
          </li>
        }
      </ul>
    }

    @if (_findings().length) {
      <ul class="approval-findings">
        @for (finding of _findings(); track $index) {
          <li
            class="approval-finding"
            [class.approval-finding--error]="finding.severity === 'error'"
            [class.approval-finding--warn]="finding.severity === 'warn'"
          >
            {{ finding.message }}
          </li>
        }
      </ul>
    }

    @if (_resolvedDecision() === 'cancelled') {
      <p class="approval-cancelled-note">{{ _cancelLabel() }}</p>
    } @else if (_resolvedDecision() === 'confirmed') {
      <!-- Confirmed: no actions, no note — identical to the live post-confirm card. -->
    } @else if (superseded()) {
      <p class="approval-cancelled-note">{{ _w.approvalSuperseded() }}</p>
    } @else {
      @if (_editedDraft()) {
        <p class="approval-edited-note">{{ _w.approvalDraftModified() }}</p>
      }
      @if (_arming()) {
        <div class="approval-actions approval-actions--arming">
          <button
            class="approval-button approval-button--arm-cancel"
            type="button"
            [style.--myre-grace-ms.ms]="_graceSeconds() * 1000"
            (click)="_onArmCancel()"
          >
            <span
              class="approval-button-arm-fill"
              [style.width.%]="_armProgress() * 100"
            ></span>
            <span class="approval-button-arm-label">{{
              _w.approvalSendCountdown({
                bindings: { seconds: _armSecondsLeft() },
              })
            }}</span>
          </button>
        </div>
      } @else {
        <div class="approval-actions">
          <button
            id="chat-approval-confirm"
            class="approval-button approval-button--confirm"
            type="button"
            [disabled]="_locked || _hasBlockingFinding()"
            (click)="_onConfirm()"
          >
            {{ _w.approvalConfirm() }}
          </button>
          <button
            id="chat-approval-cancel"
            class="approval-button approval-button--cancel"
            type="button"
            [disabled]="_locked"
            (click)="_onCancel()"
          >
            {{ _w.cancel() }}
          </button>
        </div>
      }
    }
  </div>
}
